/* 运营中心-专线包车提成规则 */
<template>
  <div id="order">

    <el-radio-group v-model="tabAction" style="margin-bottom: 15px;">
      <el-radio-button label="all">全部</el-radio-button>
      <el-radio-button v-for="item in $const.ORDERCHARTEREDSTATUS" :key="item.value" :label="item.value">
        {{ item.label }}
      </el-radio-button>
    </el-radio-group>

    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" 
      has-organization="true" hasChildren="passengerNum" loadChildrenId="id" :loadChildren="loadChildren"
      excel-type="OrderIntercity" labelWidth="135" style="height: 95%">
      <template slot="table-operation">
        <el-table-column label="操作" width="100" fixed="right">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" v-if="row.status == 5" @click="reassignmentClick(row)">派车</el-button>
            <el-button type="text" v-if="row.status == 10" @click="reassignmentClick(row)">改派</el-button>
            <el-button type="text" v-if="row.status == 5 || row.status == 1 || row.status == 10"
              @click="cancelClick(row)">退票</el-button>
            <label v-else style="color:#999">-</label>
          </div>
        </el-table-column>
      </template>

      <template slot-scope="{ item, row }">
        <template v-if="item.prop == 'created'">{{
          row.created | filterTime("YYYY-MM-DD HH:mm")
        }}</template>
        <template v-else-if="item.prop == 'schedulingTime'">
          {{ row.schedulingTime | filterTime("MM-DD") }}
          {{ row.startLineTime }}
        </template>
        <template v-else-if="item.prop == 'finishTime'">{{
          row.finishTime | filterTime("YYYY-MM-DD HH:mm")
        }}</template>
        <template v-else-if="item.prop == 'orderNo'">
          <span>{{ row.orderNo }}</span>
        </template>
        <template v-else-if="item.prop == 'passengerNum'">
          {{ row.passengerNum }}
          <el-tag v-if="row.passengerNum > 1 && !row.hide && row.ticketRestrictions == 2" effect="plain" type="success"
            style="margin-left: 8px;border: 1px solid #008080;color: #008080;cursor: pointer;"
            @click="handleConnectionSearch(row, true)">查看
          </el-tag>
          <el-tag v-if="row.passengerNum > 1 && row.hide" type="info" style="margin-left: 8px; cursor: pointer"
            @click="handleConnectionSearch(row, false)">收起
          </el-tag>
        </template>
        <template v-else-if="item.prop == 'retreatFee'">
          <template v-if="row.status == 60 || row.isTicketChanging == 1">
            <div v-if="row.status == 60">
              <span class="util-money" v-if="row.retreatFee || row.retreatFee == 0">￥{{ row.retreatFee }}</span>
              <span class="util-money" v-if="!row.retreatFee && row.retreatFee !== 0">￥0</span>
              {{ row.refundProportion }}
            </div>
            <div v-if="row.isTicketChanging == 1">
              <span class="util-money" v-if="row.ticketChangingFee || row.ticketChangingFee == 0">￥{{
                row.ticketChangingFee }}</span>
              <span class="util-money" v-if="!row.ticketChangingFee && row.ticketChangingFee !== 0">￥0
              </span>
              {{
                row.ticketChangingProportion
                ? "(" + row.ticketChangingProportion + "%改签费率" + ")"
                : "(无改签费)"
              }}
            </div>
          </template>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop == 'status'">
          <el-tag size="mini" :type="row.status | filterOrderCharteredStatusType">{{ row.status | filterOrderCharteredStatus }}</el-tag>
          <el-tooltip placement="right" v-if="row.beyondFeeStatus == 2">
            <div slot="content">
              <div v-if="row.beyondCharteredTimeFee && row.beyondCharteredMileFee">
                有￥{{ row.beyondCharteredTimeFee }}超时费、￥{{ row.beyondCharteredMileFee }}超里程费待付</div>
              <div v-else>
                <div v-if="row.beyondCharteredTimeFee">有￥{{ row.beyondCharteredTimeFee }}超时费待付</div>
                <div v-if="row.beyondCharteredMileFee">有￥{{ row.beyondCharteredMileFee }}超里程费待付</div>
              </div>
            </div>
            <i class="el-icon-warning" style="color:#f15221"></i>
          </el-tooltip>
        </template>
        <template v-else-if="item.prop == 'startStationName'">
          <div>{{ row.startStationName }}</div>
          <div style="color:#999">{{ row.startDetailAddress }}</div>
        </template>
        <template v-else-if="item.prop == 'endStationName'">
          <div>{{ row.endStationName }}</div>
          <div style="color:#999">{{ row.endDetailAddress }}</div>
        </template>
        <template v-else-if="item.prop == 'customerPhone'">
          <div>{{ row.customerPhone }}</div>
          <el-popover v-if="row.customerName" placement="top" title="实名信息" trigger="click">
            <div slot="reference" style="color:#0066FF;cursor: pointer;">查看实名信息</div>
            <div>乘客姓名：{{ row.customerName }}</div>
            <div>身份证号码：{{ row.idCard }}</div>
          </el-popover>
        </template>
        <template v-else-if="item.prop == 'charterDay'">{{ row.charterDay }}天</template>
        <template v-else-if="item.prop == 'startLineTime'">
          {{ row.schedulingTime | filterTime("MM-DD") }}
          {{ row.startLineTime }} - {{ row.endLineTime }}
        </template>
        <template v-else-if="item.prop == 'channelAlias'">
          <span>{{ row[item.prop] | filterConst("CHANNELALIAS") }}</span>
        </template>
        <template v-else-if="item.prop == 'licenseNo'">
          <span style="color: #999" v-if="row.status == 5">待指派</span>
          <template v-else>
            <span v-if="row.licenseNo" :style="getPlateStyle(row.licenseNo)">{{ formatPlateNumber(row.licenseNo) }}</span>
            <span v-if="row.vehicleSeat" style="margin-left: 4px;">{{ row.vehicleSeat }}座</span>
            <span v-if="!row.licenseNo && !row.vehicleSeat">-</span>
          </template>
        </template>
        <template v-else-if="item.prop == 'driverName'">
          <span style="color: #999" v-if="row.status == 5">待指派</span>
          <span v-if="row.status !== 5">{{
            row.driverName ? row.driverName : "-"
          }}</span>
        </template>
        <template v-else-if="item.prop == 'driverPhone'">
          <span style="color: #999" v-if="row.status == 5">待指派</span>
          <span v-if="row.status !== 5">{{
            row.driverPhone ? row.driverPhone : "-"
          }}</span>
        </template>
        <template v-else-if="item.prop == 'realFee'">
          <template v-if="row.realFee || row.realFee == 0">
            <span class="util-money">¥{{ row.realFee }}</span>
            <span v-if="row.couponFee">(优惠券<span class="util-money-minus">-{{ row.couponFee }}</span>)</span>
          </template>
          <span v-if="!row.realFee && row.realFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop == 'lineFee'">
          <span class="util-money" v-if="row.lineFee || row.lineFee == 0">
            {{
              row.schedulingType == 3 || row.railType == 2
              ? "¥" + row.lineFee + "起"
              : "¥" + row.lineFee
            }}
          </span>
          <span v-if="!row.lineFee && row.lineFee !== 0">-</span>
        </template>
        <template v-else-if="item.prop == 'score'">
          <el-rate v-model="row.score" disabled></el-rate>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <orderCustomizeCharteredVehicle :visible.sync="reassignmentVisible" :order.sync="order"
      @confirm="$refs.customTable.listFn()" />

    <el-dialog title="订单退票" :visible.sync="refundState" width="20%" @close="refundFee = null">
      <p class="tips">说明：退票手续费不能大于乘客已付的基础费用</p>
      <div class="cancel-money" style="padding-top: 20px">
        <div class="cancel-money-title">实际支付</div>
        <div class="util-money">￥{{ order.realFee }}</div>
      </div>

      <div class="cancel-money">
        <div class="cancel-money-title" style="line-height:28px">退票手续费</div>
        <div>
          <el-input v-model="refundFee"
            @input="refundFee = refundFee.replace(/^0[\d]/g, '0').replace(/(\d\d{0,6}\.?\d{0,2})?.*/g, '$1').replace(/^[1-9][0-9]{7,}/g, '9999999')"
            placeholder="请输入要扣除的退票费">
            <template #append>元</template>
          </el-input>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="cancelConfirm" :loading="loading">确 认</el-button>
        <el-button @click="refundState = false">取 消</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import orderCustomizeCharteredVehicle from "./orderCustomizeCharteredVehicle";
export default {
  name: "order",
  components: { orderCustomizeCharteredVehicle },
  data() {
    return {
      tabAction: "all",
      refundFee: null,
      refundState: false,
      loading: false,
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/order/intercity",
        // 请求的参数列表
        params: {
          page: 1, // 页数
          size: 20, // 每页条数
        },
        search: [
          { type: "input", field: "orderNo", name: "订单号", value: "" },
          { type: "input", field: "startStationName", name: "出发地", value: "" },
          { type: "input", field: "endStationName", name: "目的地", value: "" },
          { type: "input", field: "customerPhone", name: "联系电话", value: "" },
          { type: "input", field: "driverName", name: "司机姓名", value: "" },
          { type: "input", field: "driverPhone", name: "司机电话", value: "" },
          { type: "input", field: "licenseNo", name: "车辆号牌", value: "" },
          { type: "input", field: "vehicleNo", name: "车辆编号", value: "" },
          { type: "datetime", field: "time", name: "下单时间", value: [] },
          { type: "datetime", field: "finishTime", dateProp: { start: "finishStartTime", end: "finishEndTime" }, name: "完成/取消时间", value: [] }
        ],
      },
      // 表头
      columns: [
        { prop: "orderNo", label: "订单号", width: 190 },
        { prop: "status", label: "订单状态", width: 80 },
        { prop: "created", label: "下单时间", width: 130 },
        { prop: "finishTime", label: "完成/取消时间", width: 130 },
        { prop: "startStationName", label: "出发地", minWidth: 200 },
        { prop: "endStationName", label: "目的地", minWidth: 200 },
        { prop: "schedulingTime", label: "用车时间", minWidth: 100 },
        { prop: "customerPhone", label: "联系电话", width: 160 },
        { prop: "intercityName", label: "所选车型", width: 120 },
        { prop: "realFee", label: "实际支付", width: 80 },
        { prop: "licenseNo", label: "车辆号牌", width: 180 },
        { prop: "vehicleNo", label: "车辆编号", width: 120 },
        { prop: "driverName", label: "司机姓名", width: 70 },
        { prop: "driverPhone", label: "司机电话", width: 105 }
      ],
      // 状态
      status: null,
      schedulingType: null,
      order: {},
      reassignmentVisible: false,
    };
  },
  watch: {
    tabAction(val) {
      this.customOptions.params.page = 1;
      this.customOptions.params.status = val != "all" ? val : null;
      this.$refs.customTable.listFn();
    },
  },
  methods: {
    // 按钮触发展开行
    async handleConnectionSearch(row, bl) {
      if (bl) {
        let data = await this.$axios.get("/api/v1/manage/order/orderCustomer/customer/" + row.id);
        if (data && data.code == 1) {
          if (data.data.length == 0) {
            this.$message.warning("没有找到相关乘客");
          } else {
            let arr = [];
            for (const item of data.data) {
              if (item.isDefault == 1) {
                //  row.idCard = item.idCard;
                continue;
              } else {
                item.id = 9999999;
                arr.push(item);
              }
            }
            row.children = arr;
            row.hide = true;
            this.$refs.customTable.$refs.tableInner.toggleRowExpansion(row, bl);
          }
        } else {
          this.$message.error("查询错误");
        }
      } else {
        //   row.idCard = null;
        row.hide = false;
        this.$refs.customTable.$refs.tableInner.toggleRowExpansion(row, bl);
      }
    },
    // 查询订单乘客列表
    async loadChildren(tree, treeNode, resolve) {
      let data = await this.$axios.get("/api/v1/manage/order/orderCustomer/customer/" + tree.id);
      if (data && data.code == 1) {
        if (data.data.length == 0) {
          this.$message.warning("没有找到相关乘客");
        } else {
          for (const item of data.data) {
            if (item.isDefault == 1) {
              continue;
            } else {
              item.id = 9999999;
            }
          }
          resolve(data.data);
        }
      } else {
        this.$message.error("查询错误");
        resolve([{ msg: "接口错误" }]);
      }
    },
    reassignmentClick(row) {
      this.order = row;
      this.reassignmentVisible = true;
    },

    /* 退票接口 */
    cancelClick(row) {
      this.order = row;
      this.refundState = true;
    },

    /* 点击退票 */
    async cancelConfirm() {
      if (!this.refundFee) {
        this.$message.info('退票手续费不能为空')
        return;
      } else if (this.refundFee > this.order.realFee) {
        this.$message.info('说明：退票手续费不能大于乘客已付的基础费用')
        return;
      }
      this.loading = true;
      let data = await this.$axios.post("/api/v1/manage/order/intercity/cancel/" + this.order.id,
        {
          refundFee: this.refundFee
        });
      if (data && data.code === 1) {
        this.$message.success("已退票");
        this.refundFee = null;
        this.$refs.customTable.listFn();
      }

      this.loading = false;
      this.refundState = false;
    }

  },
  created() {
    if (this.$route.query.status) {
      this.customOptions.params.status = this.$route.query.status;
      this.tabAction = this.customOptions.params.status;
    }
  },
};
</script>

<style lang="less">
.el-popover__title {
  margin-bottom: 5px;
  font-size: unset;
  font-weight: bold;
}


#order {
  .el-dialog {
    .customTable-top {
      display: flex;
      align-items: center;
      justify-content: space-between;
    }

    .dialog-line-list {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .el-tabs {
      .el-tabs__header {
        margin: 0;
      }

      .el-tabs__nav-wrap::after {
        background-color: transparent;
      }
    }

    .el-dialog__body {
      padding-top: 10px;
    }

    .dialog-top {
      display: flex;
      line-height: 28px;
      font-size: 14px;
      margin-bottom: 12px;

      .dialog-top-item+.dialog-top-item {
        margin-left: 16px;
      }

      .line-name {
        width: 300px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .dialog-table {
      /*height: 500px;*/
    }

    .table-operation-choose {
      cursor: pointer;
      color: @color-primary;
    }
  }

  .cancel-money {
    display: flex;
    justify-content: space-between;

    .cancel-money-title {
      font-weight: 600;
    }

    .cancel-money-money {
      font-weight: 600;
    }

    .util-money {
      padding-left: 8px;
    }
  }

  .cancel-money+.cancel-money {
    padding-top: 14px;
  }

  .el-table__expand-icon {
    display: none;
  }
}
</style>
